import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'
import { LKHeader } from 'loankeeper-common/components'

import { Container, SegmentGroup, GridContainer, FakeInput } from 'shared/StyledComponents'
import { translateBase, icon } from '../helpers'

const General = ({ data }) => (
  <Container>
    <SegmentGroup>
      <Segment.Group>
        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_grp_fullname_t')}
                </Grid.Column>

                <Grid.Column width={12}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{data.FullName}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_grp_businesstype_t')}
                </Grid.Column>

                <Grid.Column width={12}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.BusinessType}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_grp_industry_t')}
                </Grid.Column>

                <Grid.Column width={12}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Industry}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_grp_address_t')}
                </Grid.Column>

                <Grid.Column width={12}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {`
                                                    ${data.AddressBus}, ${data.CityBus},
                                                    ${data.DistrictBus}, ${data.ZoneBus},
                                                    ${data.TerritoryBus}, ${data.RegionBus},
                                                    ${data.CountryBus}
                                                `}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_grp_address_details_t')}
                </Grid.Column>

                <Grid.Column width={12}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {`
                                                    ${data.ZipCodeBus} /
                                                    ${parseInt(data.DistanceBus, 10)} /
                                                    ${data.UrbanBus}
                                                `}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_grp_phone')}
                </Grid.Column>

                <Grid.Column width={6}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Phone}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column width={6}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.CellPhone}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>
      </Segment.Group>
    </SegmentGroup>
  </Container>
)

General.config = {
  title: () => translateBase('tb_ind_1'),
  name: 'general',
  component: General,
  api: 'base',
  icon: icon('tb_ind_1'),
}

export default General
